import React, { useContext } from 'react';
import moment from 'moment';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const DateChip = ({ value }) => {
  const { shortDateFormat } = useContext(ConfigContext);

  if (!Array.isArray(value)) {
    return <FlexMiddle>{moment(value).format(shortDateFormat)}</FlexMiddle>;
  }

  return <FlexMiddle>{value.map((date) => moment(date).format(shortDateFormat)).join(', ')}</FlexMiddle>;
};

export default DateChip;
